export default __webpack_public_path__ + "static/media/618.32210f99.gif";